export const resolveScormErrorMessage = (error: unknown): string | null => {
  if (!error) return null;

  const status =
    typeof error === 'object' && error !== null && 'status' in error
      ? (error as { status?: unknown }).status
      : null;

  if (status === 403) {
    return 'No access to SCORM analytics, or the report is not available on this server yet.';
  }

  if (status === 404) {
    return 'Package not found.';
  }

  if (status === 503) {
    return 'The service is temporarily unavailable — it is most likely restarting. Try again in a minute.';
  }

  const serverMessage =
    typeof error === 'object' && error !== null && 'data' in error
      ? (error as { data?: { message?: string } }).data?.message
      : undefined;

  return serverMessage || 'Could not load the report. Please try again.';
};
